import { businessUrl } from "../config/env";
import request from "../config/axios";

export const labqrcodedatashow = (query) =>request({
    url:`${businessUrl}biz/Region/list`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//20260101 add
//获取书籍一级类型
export const getBookOneType = (query) =>request({
    url:`${businessUrl}biz/BookOnetype/onetypelist`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//获取书籍二级类型
export const getBookTwoType = (query) =>request({
    url:`${businessUrl}biz/BookTwotype/twotypelist`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//获取特别推荐书籍
export const getBookRecommand = (query) =>request({
    url:`${businessUrl}biz/BookSeries/serieslist`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//获取即将出版书籍
export const getBookWillPub = (query) =>request({
    url:`${businessUrl}biz/BookWillpub/willpublist`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//获取系列书籍的分册
export const getSingleBook = (query) =>request({
    url:`${businessUrl}biz/BookInfo/booklist`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//获取系列书籍的分册的章节和页码二级菜单数据
export const getChapterpagelist = (query) =>request({
    url:`${businessUrl}biz/BookChapter/chapterpagelist`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//获取系列书籍(无分册)章节和页码二级菜单数据
export const getBookpagelist = (query) =>request({
    url:`${businessUrl}biz/BookSeries/bookpagelist`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//Meilisearch关键词搜索书籍的内容
export const getSearchBook = (query) =>request({
    url:`${businessUrl}biz/BookSeries/booksearch`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//Meilisearch搜索获取书籍的各个页码上的正文
export const getBookpagecontent = (query) =>request({
    url:`${businessUrl}biz/BookSeries/bookpagecontent`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//获取系列书籍的详情
export const getBookDetail = (query) =>request({
    url:`${businessUrl}biz/BookSeries/bookdetail`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//获取系列书籍的详情
export const getPublishDetail = (query) =>request({
    url:`${businessUrl}biz/BookWillpub/bookdetail`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//获取用户的详情信息
export const getUserInfo = (query) =>request({
    url:`${businessUrl}biz/UserInfo/getUserInfo`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//获取vip用户的书籍名称
export const getVipuserBook = (query) =>request({
    url:`${businessUrl}biz/BookSeries/getVipuserBook`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//获取我的书籍列表信息
export const getMyVipBook = (query) =>request({
    url:`${businessUrl}biz/BookSeries/myserieslist`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})

//根据简体文字获取繁体文字
export const getTradChineseOfSimple = (query) =>request({
    url:`${businessUrl}biz/BookSeries/getTradChineseOfSimple`,
    method:"GET",
    headers:{
        isToken:false
    },
    params:query
})


// WEBPACK FOOTER //
// ./src/api/home.js